const extraServices = {
  header: {
    btnCreate: 'הוסף',
  },

  toast: {
    error: {
      badResponse: '[שירותים נוספים] תגובת שרת שגויה',
      create: {},
      edit: {},
    },
    success: {
      create: {
        default: '[שירותים נוספים] נוצר בהצלחה',
      },
      edit: {},
      delete: {
        default: '[שירותים נוספים] נמחק בהצלחה',
      },
    },
  },

  deleteModal: {
    header: 'מחק שירותים נוספים',
    body: 'אתה עומד למחוק {{num}} שירותים נוספים.',
  },

  table: {
    filters: {
      profileType: 'סוג פרופיל'
    },
    headers: {
      name: 'שירות נוסף',
      profileType: 'סוג פרופיל',
      basePrice: 'בסיס',
      extraPrice: 'כל תוספת',
      baseUpTo: 'בסיס עד',
      surcharge: 'תוספת מחיר',
    },
    actions: {
      delete: 'מחק',
      export: 'ייצא',
    },
  },

  create: {
    successToast: {
      message: 'הצלחה! השירות הנוסף נוצר',
    },
    errorToast: {
      message: 'אירעה שגיאה. לא ניתן ליצור שירות נוסף',
    },
  },

  edit: {
    successToast: {
      message: 'הצלחה! השירות הנוסף עודכן',
    },
    errorToast: {
      message: 'אירעה שגיאה. לא ניתן לעדכן שירות נוסף',
    },
  },

  forms: {
    header: {
      createExtraService: {
        title: 'הוסף',
      },

      updateExtraService: {
        title: 'עדכן',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'שמור',
        update: 'שמור',
      },
    },

    information: {
      details: {
        header: 'פרטים',
        fields: {
          name: 'שירות נוסף',
          profileType: 'סוג פרופיל',
          description: 'תיאור',
          profileTypeOptions: {
            retail: 'קמעונאות',
            individual: 'פרטי',
            wholesale: 'סיטונאות',
            corporate: 'תאגידי',
            website: 'אתר אינטרנט',
            hotel: 'מלון',
            thirdParty: 'צד שלישי',
            tourOperator: 'מפעיל תיירות',
            receiptiveOperator: 'מפעיל קולט',
          },
        },
      },
      settings: {
        header: 'הגדרות',
        fields: {
          basePrice: 'בסיס',
          extraPrice: 'כל תוספת',
          baseUpTo: 'בסיס עד',
          surcharge: 'תוספת מחיר',
        },
      },
    },
  },
};

export default extraServices;
